import { Injectable, signal } from '@angular/core';
import { AngularFireDatabase } from '@angular/fire/compat/database';
import { EnvironmentWidget, NewCompaniesKpi, NewCompaniesKpiPerCustomerType } from '../models';

@Injectable({
  providedIn: 'root',
})
export class KpiService {

  placeholder = [];
  summedTotal: NewCompaniesKpiPerCustomerType;
  
  newCompaniesState = signal<EnvironmentWidget[]>(null);
  summedTotalState = signal<NewCompaniesKpiPerCustomerType>(null);

  environments: string[] = [
    'Ext01',
    'Softrig01',
    'Softrig02',
    'Softrig03',
    'Softrig04',
    'Softrig05',
    'Softrig06',
    'Softrig07',
    // Softrig08
    'Softrig09',
    //'Softrig10',
    'Softrig11',
    // Softrig12
    //'Softrig13',
    'Softrig19',
  ];

  constructor(
    private firebase: AngularFireDatabase,
  ) {    
    this.firebase
      .object('/global-kpi/environments')
      .valueChanges()
      .subscribe((data: any) => {
        if (data) {
          this.placeholder = [];
          this.extractNewCompaniesData(data);
        }
      });
  }

  extractNewCompaniesData(data: any) {    
    this.summedTotal = {
      Total: {
        NewCompaniesToday: 0,
        NewCompaniesThisMonth: 0,
        NewCompaniesLastMonth: 0,
        NewCompaniesThisYear: 0,
        Total: 0
      },
      CustomerTypeBureau: {
        NewCompaniesToday: 0,
        NewCompaniesThisMonth: 0,
        NewCompaniesLastMonth: 0,
        NewCompaniesThisYear: 0,
        Total: 0
      },
      CustomerTypeStandard: {
        NewCompaniesToday: 0,
        NewCompaniesThisMonth: 0,
        NewCompaniesLastMonth: 0,
        NewCompaniesThisYear: 0,
        Total: 0
      },
    };

    this.environments.forEach(env => {
      this.placeholder.push({
        environment: env,
        data: data[env]
      });

      this.summedTotal.Total.NewCompaniesToday += data[env]?.NewCompaniesToday || 0;
      this.summedTotal.Total.NewCompaniesThisMonth += data[env]?.NewCompaniesThisMonth || 0;
      this.summedTotal.Total.NewCompaniesLastMonth += data[env]?.NewCompaniesLastMonth || 0;
      this.summedTotal.Total.NewCompaniesThisYear += data[env]?.NewCompaniesThisYear || 0;
      this.summedTotal.Total.Total += data[env]?.Total || 0;

      this.summedTotal.CustomerTypeBureau.NewCompaniesToday += data[env]?.CustomerTypeBureau.NewCompaniesToday || 0;
      this.summedTotal.CustomerTypeBureau.NewCompaniesThisMonth += data[env]?.CustomerTypeBureau.NewCompaniesThisMonth || 0;
      this.summedTotal.CustomerTypeBureau.NewCompaniesLastMonth += data[env]?.CustomerTypeBureau.NewCompaniesLastMonth || 0;
      this.summedTotal.CustomerTypeBureau.NewCompaniesThisYear += data[env]?.CustomerTypeBureau.NewCompaniesThisYear || 0;
      this.summedTotal.CustomerTypeBureau.Total += data[env]?.CustomerTypeBureau.Total || 0;

      this.summedTotal.CustomerTypeStandard.NewCompaniesToday += data[env]?.CustomerTypeStandard.NewCompaniesToday || 0;
      this.summedTotal.CustomerTypeStandard.NewCompaniesThisMonth += data[env]?.CustomerTypeStandard.NewCompaniesThisMonth || 0;
      this.summedTotal.CustomerTypeStandard.NewCompaniesLastMonth += data[env]?.CustomerTypeStandard.NewCompaniesLastMonth || 0;
      this.summedTotal.CustomerTypeStandard.NewCompaniesThisYear += data[env]?.CustomerTypeStandard.NewCompaniesThisYear || 0;
      this.summedTotal.CustomerTypeStandard.Total += data[env]?.CustomerTypeStandard.Total || 0;
    });

    this.buildIt();
  }

  buildIt() {
    const beast: EnvironmentWidget[] = [];

    this.placeholder.forEach(p => {
      beast.push({
        environment: p.environment,
        data: {
          Total: this.sumNewCompaniesByCustomerType(p.environment),
          CustomerTypeBureau: this.sumNewCompaniesByCustomerType(p.environment, 'CustomerTypeBureau'),
          CustomerTypeStandard: this.sumNewCompaniesByCustomerType(p.environment, 'CustomerTypeStandard'),
        },
      });
    });

    this.newCompaniesState.set(beast);
    //this.summedTotalState.set(this.summedTotal);
    this.summedTotalState.set(this.summedTotal);
  }

  sumNewCompaniesByCustomerType(env: string, customerType?: string): NewCompaniesKpi {
    const subEnvironments = this.placeholder.filter(p => p.environment === env);
    return subEnvironments.reduce((acc, curr) => {
      acc.NewCompaniesToday += customerType ? curr.data[customerType].NewCompaniesToday : curr.data.NewCompaniesToday;
      acc.NewCompaniesThisMonth += customerType ? curr.data[customerType].NewCompaniesThisMonth : curr.data.NewCompaniesThisMonth;
      acc.NewCompaniesLastMonth += customerType ? curr.data[customerType].NewCompaniesLastMonth : curr.data.NewCompaniesLastMonth;
      acc.NewCompaniesThisYear += customerType ? curr.data[customerType].NewCompaniesThisYear : curr.data.NewCompaniesThisYear;
      acc.Total += customerType ? curr.data[customerType].Total : curr.data.Total;
      return acc;
    }, {
      NewCompaniesToday: 0,
      NewCompaniesThisMonth: 0,
      NewCompaniesLastMonth: 0,
      NewCompaniesThisYear: 0,
      Total: 0
    });
  }
}